<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ title }}</h1>
      <b-field
        :type="{ 'is-danger': errors.has('mercurio_id') }"
        :message="errors.first('mercurio_id')"
        horizontal
        :label="$translate('id_mercury') | capitalize"
      >
        <b-input name="mercurio_id" v-model="user.mercurio_id"></b-input>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
        horizontal
        :label="$translate('name') | capitalize"
      >
        <b-input name="name" v-model="user.name" v-validate="'required'"></b-input>
      </b-field>

      <b-field
        :type="{ 'is-danger': errors.has('surname') }"
        :message="errors.first('surname')"
        horizontal
        :label="$translate('surname') | capitalize"
      >
        <b-input name="surname" v-model="user.surname" v-validate="'required'"></b-input>
      </b-field>
      <b-field
        v-if="id == 0"
        :type="{ 'is-danger': errors.has('password') }"
        :message="errors.first('password')"
        horizontal
        :label="$translate('password') | capitalize"
      >
        <b-input type="password" name="password" v-model="password" v-validate="'required'"></b-input>
      </b-field>
      <b-field
        v-if="id == 0"
        :type="{ 'is-danger': errors.has('confirm_password') }"
        :message="errors.first('confirm_password')"
        horizontal
        :label="$translate('confirm_password') | capitalize"
      >
        <b-input
          type="password"
          name="confirm_password"
          v-model="confirmPassword"
          v-validate="{ required: true, is: password }"
        ></b-input>
      </b-field>
      <b-field
        :type="{ 'is-danger': errors.has('language') }"
        :message="errors.first('language')"
        horizontal
        :label="$translate('language') | capitalize"
      >
        <b-select name="language" v-model="language" v-validate="'required'">
          <option value="de">de</option>
          <option value="dk">dk</option>
          <option value="en">en</option>
          <option value="fr">fr</option>
          <option value="it">it</option>
        </b-select>
      </b-field>
      <b-field
        horizontal
        :label="$translate('username') | capitalize"
        :type="{ 'is-danger': errors.has('username') }"
        :message="errors.first('username')"
      >
        <b-input name="username" v-validate="'required'" v-model="user.username"></b-input>
      </b-field>

      <b-field
        horizontal
        :label="$translate('mail') | capitalize"
        :type="{ 'is-danger': errors.has('email') }"
        :message="errors.first('email')"
      >
        <b-input name="email" v-validate="'email|required'" v-model="user.email" :disabled="id != 0"></b-input>
      </b-field>
      <b-field horizontal :label="$translate('type_user') | capitalize">
        <b-select
          :placeholder="$translate('selection_type_user') | capitalize"
          v-model="user.type"
          @input="emptyValues"
        >
          <option value="C" key="C">C - {{ $translate('user_c') | capitalize }}</option>
          <option value="I" key="I">I - {{ $translate('user_i') | capitalize }}</option>
          <option value="A" key="A">A - {{ $translate('user_a') | capitalize }}</option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('level_user') | capitalize" v-if="user.type == 'C' || user.type == 'I'">
        <b-select :placeholder="$translate('selection_level_user') | capitalize" v-model="user.level">
          <option value="1" key="1">1 - {{ $translate('user_level_1') }}</option>
          <option value="2" key="2">2 - {{ $translate('user_level_2') }}</option>
          <option value="S" key="S">S - {{ $translate('user_level_s') }}</option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('customer') | capitalize" v-if="user.type == 'I'">
        <b-select :placeholder="$translate('selection_customers') | capitalize" v-model="user.companiesId" multiple>
          <option v-for="company in companies" :value="company.id" :key="company.id">{{ company.name }}</option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('customer') | capitalize" v-if="user.type == 'C'">
        <b-select
          :placeholder="$translate('selection_customer') | capitalize"
          v-model="user.companyId"
          @input="loadShops"
        >
          <option v-for="company in companies" :value="company.id" :key="company.id">{{ company.name }}</option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('shops') | capitalize" v-if="user.type == 'C'">
        <b-select :placeholder="$translate('selection_shops') | capitalize" v-model="user.shopsId" multiple>
          <option v-for="shop in shops" :value="shop.id" :key="shop.id">{{ shop.name }}</option>
        </b-select>
      </b-field>
      <b-field horizontal>
        <b-button type="is-primary" @click="send">{{ title }}</b-button>
      </b-field>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import firebase from 'firebase'
import utilities from '../../helpers/mixins/utilities'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'userForm',
  mixins: [utilities],
  data() {
    //var now = new Date();
    return {
      user: {
        email: '',
        name: '',
        surname: '',
        type: '',
        level: '',
        companiesId: [],
        companyId: '',
        shopsId: [],
        mercurio_id: '',
      },
      companies: [],
      shops: [],
      title: '',
      id: 0,
      password: null,
      confirmPassword: null,
      language: null,
      isLoading: false,
      userid: 0,
    }
  },
  created() {},
  methods: {
    send() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.id == 0) {
            this.newRequest()
          } else {
            this.updateRequest()
          }
        }
      })
    },
    async newRequest() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.user.email, this.password)
        .then(async () => {
          let tempuser = {}
          tempuser.email = this.user.email
          tempuser.language = this.language
          tempuser.username = this.user.username

          this.user.registeredAt = new Date().getTime()
          await this.$db
            .collection('usersInfo')
            .add(this.user)
            .then(() => {})

          await this.$db
            .collection('users')
            .add(tempuser)
            .then(() => {
              this.$router.push({ name: 'users' })
            })
        })
        .catch(error => {
          this.notification(error.message, 'is-danger')
        })
    },
    updateRequest() {
      if (!this.userid) {
        this.notification(this.$translate('user_account_not_linked'), 'is-danger')
        return
      }
      var batch = this.$db.batch()
      var orderref = this.$db.collection('usersInfo').doc(this.id)
      batch.update(orderref, this.user)

      var orderref2 = this.$db.collection('users').doc(this.userid)
      batch.update(orderref2, { language: this.language, username: this.user.username })

      batch
        .commit()
        .then(() => {
          this.$router.push({ name: 'users' })
        })
        .catch(error => {
          this.notification(error.message, 'is-danger')
        })
    },
    loadCompanies() {
      this.companies = [{ id: '*', name: 'ALL' }]
      this.$db
        .collection('companies')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            var company = doc.data()
            company.id = doc.id
            this.companies.push(company)
          })
        })
    },
    loadShops(companyId) {
      this.user.shopsId = []
      this.shops = [{ id: '*', name: 'ALL' }]
      this.$db
        .collection('shops')
        .where('companyId', '==', companyId)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            var shop = doc.data()
            shop.id = doc.id
            this.shops.push(shop)
            if (this.shopsIdBackup) {
              this.user.shopsId = this.shopsIdBackup
            }
          })
        })
    },
    loadUserToEdit() {
      this.isLoading = true
      this.$db
        .collection('usersInfo')
        .doc(this.id)
        .get()
        .then(doc => {
          this.user = doc.data()
          if (this.user.type == 'C') {
            this.shopsIdBackup = this.user.shopsId
            this.loadShops(this.user.companyId)
          }
          this.$db
            .collection('users')
            .where('email', '==', this.user.email)
            .get()
            .then(snap => {
              snap.forEach(doc2 => {
                this.language = doc2.data().language
                this.userid = doc2.id
              })
              this.isLoading = false
            })
        })
    },
    emptyValues() {
      this.user.level = ''
      this.user.companiesId = []
      this.user.companyId = ''
      this.user.shopsId = []
      this.shops = []
    },
  },
  mounted() {
    if (this.$store.getters.user.userInfo.type !== 'A') {
      this.$router.push('/forbidden')
      return
    }
    this.id = this.$route.params.id ? this.$route.params.id : 0
    this.title = this.id != 0 ? 'Modifica utente' : 'Nuovo utente'
    this.loadCompanies()
    this.id != 0 ? this.loadUserToEdit() : this.$router.push({ name: 'newUser' })
  },
}
</script>
